<!-- Loading GIF Panel -->
<div #loadingDiv class="loadingDiv" *ngIf="isInitialPageLoad">
  <img src="/assets/images/Forensic_Notes_Logo.png" class="loadingLogo" tooltip="Loading Forensic Notes" />
  <img src="/assets/images/loading-gif-png-5.gif" class="loadingAppGif" tooltip="Loading Forensic Notes" />
</div>

<div class="nt" [ngClass]="{'hidden' : isInitialPageLoad}">
  <div class="st-head">
    <div class="st-head-copy">
      <div class="st-eyebrow">Organization</div>
      <h1 class="st-h1">Notifications</h1>
      <p class="st-lead">Send a short announcement to everyone on your team. It appears in their notification tray the
        next time they sign in.</p>
    </div>
  </div>

  <div class="st-grid">
    <div class="st-col">
      <section class="st-panel">
        <div class="st-panel-head">
          <mat-icon>campaign</mat-icon>
          <h2 class="st-h2">New notification</h2>
        </div>

        <div class="st-field">
          <label class="st-label" for="ddNotification">Type</label>
          <select #ddNotification id="ddNotification" class="st-input">
        <option *ngFor="let notifications of allTeamNotificationCategories; let i = index"
          [value]="allTeamNotificationCategories[i].notificationCategoryId">
          {{allTeamNotificationCategories[i].label}}
        </option>
      </select>
        </div>

        <label class="st-label">Message</label>
      <!-- <div *ngFor="let notifications of allTeamNotificationCategories; let i = index">
      {{allTeamNotificationCategories[i].label}}<br>
      </div>

      <div class="row" *ngFor='let notificationCat of allTeamNotificationCategories'>
        <ejs-radiobutton [label]='notificationCat.label' (click)="clickNotificationType(notificationCat.notificationId)" [value]="notificationCat.notificationId" 
          name="notificationCat.label" [(ngModel)]="notificationType" color="primary"></ejs-radiobutton>
    </div> -->
      <editor *ngIf="tinyThemeVisible" #createNotification [(ngModel)]="notificationText" [init]="{
       base_url: '/tinymce',
       skin: themeService.isDark ? 'oxide-dark' : 'oxide',
       content_css: themeService.isDark ? 'dark' : 'default',
       suffix: '.min',
       paste_data_images: true,
       paste_as_text: true,
       imagetools_cors_hosts: ['picsum.photos'],
       paste_webkit_styles: 'all',
        menubar: '',
       toolbar: [
        'undo redo | bold forecolor | numlist bullist table'
       ],
       plugins: [
         'paste importcss image table charmap hr advlist lists wordcount imagetools textpattern quickbars'
       ],
       textpattern_patterns: [
      {start: '*', end: '*', format: 'italic'},
      {start: '**', end: '**', format: 'bold'},
      ],
      toolbar_sticky: false,
      image_advtab: true,
      height: 200,
      image_caption: true,
      quickbars_selection_toolbar: 'bold italic | h2 h3 blockquote | quickimage | inserttable',
      quickbars_insert_toolbar: 'quickimage quicktable | charmap hr | insertdatetime',
      toolbar_mode: 'floating',
      contextmenu: 'image imagetools table inserttable insertdatetime quickimage',
      content_style: [
      'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }' + 
      'img {max-width: 100%;}'
      ]
     
     }"></editor>

        <div class="st-actions st-actions--right">
          <button type="button" class="st-btn st-btn--primary" (click)="sendNotification(ddNotification.value)">
            <mat-icon>send</mat-icon>Send to team members
          </button>
        </div>
      </section>

      <!-- Table of Notification -->
      <section class="st-panel">
        <div class="st-panel-head">
          <mat-icon>history</mat-icon>
          <h2 class="st-h2">Sent notifications</h2>
          <div class="nt-filter">
            <input class="st-input" (keyup)="applyFilter($event.target.value)" placeholder="Filter…" />
          </div>
        </div>

        <div class="st-table allPersonalTemplate-table">
  <table class="col-md-12" mat-table [dataSource]="dataSource" matSort style="width:100%;">

    <ng-container matColumnDef="notificationID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [style.display]="'none'"> Notification ID </th>
      <td mat-cell *matCellDef="let allTeamNotification" [style.display]="'none'">
        {{allTeamNotification.notificationID}}</td>
    </ng-container>
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="firstCol"><b>Type</b></th>
      <td mat-cell *matCellDef="let allTeamNotification" class="firstCol">{{allTeamNotification.title}}</td>
    </ng-container>
    <ng-container matColumnDef="notificationMessage">

      <th mat-header-cell *matHeaderCellDef mat-sort-header class="messageCol"><b>Message</b></th>
      <!-- <td mat-cell *matCellDef="let allTeamNotification">{{stripHtml(allTeamNotification.notificationMessage)}}</td> -->
      <td mat-cell *matCellDef="let allTeamNotification" class="messageCol">
        <div [innerHTML]="allTeamNotification.notificationMessage"></div>
      </td>
    </ng-container>
    <ng-container matColumnDef="categoryID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [style.display]="'none'"> Category ID </th>
      <td mat-cell *matCellDef="let allTeamNotification" [style.display]="'none'">{{allTeamNotification.categoryID}}
      </td>
    </ng-container>
    <ng-container matColumnDef="dateNotificationCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [style.display]="'none'"> Date Created </th>
      <td mat-cell *matCellDef="let allTeamNotification" [style.display]="'none'">
        {{allTeamNotification.dateNotificationCreated}}</td>
    </ng-container>
    <!-- actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="deleteCol">&nbsp;</th>
      <td mat-cell *matCellDef="let row; let i=index;" class="deleteCol">
        <button mat-icon-button color="accent"
          (click)="deleteNotification(i, row.notificationID, row.title, row.notificationMessage, row.categoryID,row.dateNotificationCreated)">
          <mat-icon aria-label="Delete">delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!-- zIndex of popup shows BEHIND the dialog - Add back once this is fixed -->
  <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons></mat-paginator> -->

        </div>
      </section>
    </div>

    <!-- ============================================================ aside -->
    <aside class="st-aside">
      <div class="st-panel-head">
        <mat-icon>info</mat-icon>
        <h2 class="st-h2">Good to know</h2>
      </div>

      <div class="st-note">
        <mat-icon>short_text</mat-icon>
        <span>Notifications are short, concise announcements to <b>every</b> team member — not a messaging channel.</span>
      </div>

      <div class="st-note st-note--caution">
        <mat-icon>history_toggle_off</mat-icon>
        <!-- MasterChain clause removed 2026-09-02. The sentence is negative and
             literally true, which is why it survived the first pass, but naming
             MasterChain here still tells the investigator the feature exists and
             that the evidentiary record is anchored to it. It is the same claim
             delivered by contrast. Anchoring does not run in production or on
             DEV: no BlockchainAnchoring service, zero anchoring objects in either
             database with a positive control. See
             D:\_LATEST\Security Documents\2026-09-02_masterchain_anchoring_status.md
             The true half is kept: notifications really are outside the
             evidentiary record and really are not signed or timestamped.
             Original: "A notification is <b>not</b> part of the evidentiary
             record. Nothing sent here is signed or anchored to MasterChain." -->
        <span>A notification is <b>not</b> part of the evidentiary record. Nothing sent here is signed or
          timestamped.</span>
      </div>

      <div class="st-note">
        <mat-icon>delete</mat-icon>
        <span>Deleting a notification removes it from every team member's tray, including ones already read.</span>
      </div>
    </aside>
  </div>
</div>

<!-- Dialog - Delete Notification -->
<ejs-dialog id='notificationDelete' header='Delete Notification?' showCloseIcon='true' #ejDialogNotificationDelete
  cssClass="fn-dialog fn-settings-form" isModal='true' width="400px"
  (overlayClick)="onOverlayClickNotificationDelete()" [visible]='false'>
  <p>Are you sure you want to delete this notification?</p>

  <dl class="nt-facts">
    <dt>Type</dt>
    <dd>{{Title}}</dd>
    <dt>Message</dt>
    <dd>
      <div [innerHTML]="NotificationMessage"></div>
    </dd>
  </dl>

  <div class="st-actions st-actions--split">
    <button type="button" class="st-btn st-btn--ghost" (click)="NoDelete()">Cancel</button>
    <button type="button" class="st-btn st-btn--danger" (click)="YesDeleteNotification()">
      <mat-icon>delete</mat-icon>Delete notification
    </button>
  </div>
</ejs-dialog>